import { createActionCreators } from 'immer-reducer';

import { AuthReducer } from '@/store/reducers/auth';

export const authActions = createActionCreators(AuthReducer);

export type AuthActions =
  | ReturnType<typeof authActions.signIn>;
